import { PhaseLabels } from '../types';
import global from './global';
import { isDefined } from './util';
// Note: The names of the enum values are prefixed with 'ERROR_' to indicate that they are errors, not warnings.
// The 'MAINS_' prefix indicates warnings related to the mains circuit breaker.
export var EnergyProWarning;
(function (EnergyProWarning) {
    EnergyProWarning["INACTIVE_PORT_WITH_ATTACHED_EQUIPMENT"] = "INACTIVE_PORT_WITH_ATTACHED_EQUIPMENT";
    EnergyProWarning["DETECTED_PHASES_LESS_THAN_EXPECTED"] = "DETECTED_PHASES_LESS_THAN_EXPECTED";
    EnergyProWarning["ERROR_DETECTED_PHASES_MORE_THAN_EXPECTED"] = "ERROR_DETECTED_PHASES_MORE_THAN_EXPECTED";
    EnergyProWarning["ERROR_MAINS_REVERSE_POLARITY"] = "ERROR_MAINS_REVERSE_POLARITY";
    EnergyProWarning["ERROR_MAINS_INCORRECT_PHASE"] = "ERROR_MAINS_INCORRECT_PHASE";
})(EnergyProWarning || (EnergyProWarning = {}));
export const energyProWarningToLabelMapping = {
    [EnergyProWarning.INACTIVE_PORT_WITH_ATTACHED_EQUIPMENT]: 'Equipment attached to an inactive port',
    [EnergyProWarning.DETECTED_PHASES_LESS_THAN_EXPECTED]: 'AC system detected by EnergyPro II is lower than the one created in the configuration.',
    [EnergyProWarning.ERROR_DETECTED_PHASES_MORE_THAN_EXPECTED]: 'AC system detected by EnergyPro II exceeds the one created in the configuration. Please recreate the distribution panel with the correct AC system.',
    [EnergyProWarning.ERROR_MAINS_REVERSE_POLARITY]: 'The Main CT seems to be installed in the wrong direction. Please change its direction immediately.',
    [EnergyProWarning.ERROR_MAINS_INCORRECT_PHASE]: 'Incorrect Phase. Please verify if the CT is monitoring the correct phase.',
};
export const determinePhaseDisplayAndSource = (configuredPhase, detectedPhase) => {
    let phaseLabel;
    let phaseSource;
    if (!isDefined(configuredPhase)) {
        phaseLabel = global.NOT_AVAILABLE;
        phaseSource = global.NOT_AVAILABLE;
    }
    else if (configuredPhase === 0) {
        if (detectedPhase === 0 || !detectedPhase) {
            phaseLabel = global.NOT_AVAILABLE;
            phaseSource = 'C';
        }
        else {
            phaseLabel = detectedPhase
                ? PhaseLabels[detectedPhase]
                : global.NOT_AVAILABLE;
            phaseSource = 'A';
        }
    }
    else {
        phaseLabel = PhaseLabels[configuredPhase] || configuredPhase;
        phaseSource = 'M';
    }
    return { phaseLabel, phaseSource };
};
